import { Tablet } from "@material-ui/icons";
import { MobileAppVersionsList } from "./MobileAppVersionsList";
import { MobileAppVersionCreate } from "./MobileAppVersionCreate";

export default {
  icon: Tablet,
  list: MobileAppVersionsList,
  create: MobileAppVersionCreate,
};
